import React from "react";
import { MainModal } from "../../../../components/modal/MainModal";

export const Dialog = ({ primaryBtnHandler, onClose, children }) => {
  return (
    <MainModal
      isOpen
      containerClassName="dialog"
      parentSelector=".referral-categories"
      width={300}
      height="auto"
      headerCloseHandler={onClose}
      primaryButtonText="Yes"
      primaryBtnHandler={() => {
        primaryBtnHandler();
        onClose();
      }}
      secondaryBtnText="No"
      secondaryBtnHandler={onClose}
      onClose={onClose}
    >
      {children}
    </MainModal>
  );
};
